import Swiper from 'swiper/bundle';

export default function () {
    let $productSwiper = $('.catalog-goods--swipe');

    if ($productSwiper.length === 0) {
        return false;
    }

    $.each($productSwiper, (index, element) => {
        let currentSlider = $(element);

        new Swiper(element, {
            slidesPerView: 'auto',
            wrapperClass: 'catalog-goods__list',
            slideClass: 'catalog-goods__list .cell',
            spaceBetween: 0,
            slidesPerGroup: 5,
            simulateTouch: true,
            slideVisibleClass: 'showed',
            navigation: {
                nextEl: '.catalog-goods--swipe .swiper-controls__next',
                prevEl: '.catalog-goods--swipe .swiper-controls__back',
            },
            breakpoints: {
                1280: {
                    slidesPerView: 5,
                    spaceBetween: 0,
                    slidesPerGroup: 5,
                },
                879: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                    slidesPerGroup: 3,
                },
                641: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesPerGroup: 2,
                },
                570: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesPerGroup: 1,
                },
                470: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesPerGroup: 1,
                },
            },
        });

        currentSlider.attr('data-sliderindex', index);
    });
}
